import { render, staticRenderFns } from "./assessment-panel-mobile.vue?vue&type=template&id=1468ec04&scoped=true&"
import script from "./assessment-panel-mobile.vue?vue&type=script&lang=ts&"
export * from "./assessment-panel-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-panel-mobile.vue?vue&type=style&index=0&id=1468ec04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1468ec04",
  null
  
)

export default component.exports